// import { loadManifest } from '@angular-architects/module-federation';
import { loadManifest, setManifest } from '@angular-architects/module-federation';
import { environment } from '../../../environments/environments';

// PREVENT MODULES FROM BEING PRELOADED
const stopPreloadModules = true;
// USES ANGULAR ENVIRONMENT FILES TO DRIVE ROUTES/MODULES
const composedManifest = Object.assign({ "remoteEntry": "" }, environment.routes);
// @ts-ignore
setManifest(composedManifest, stopPreloadModules);

import('./loadTranslations')



